import "reflect-metadata";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import PACKAGE from "../package.json";
import * as Sentry from "@sentry/react";
import routes from "@/config/Routes.tsx";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

console.info(`%c v${PACKAGE.version} / ${import.meta.env.VITE_BACKEND_HOST}`, "font-weight:bold;color:coral;font-size:20px");

async function enableMocking() {
    if (import.meta.env.VITE_MOCKING !== "true") {
        return;
    }
    const { worker } = await import("./mocks/Browser.ts");
    return worker.start({
        quiet: false,
        waitUntilReady: true,
    });
}

Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost"],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    enabled: import.meta.env.VITE_ENV === "prod",
});

const router = createBrowserRouter(routes);
enableMocking().then(() => {
    createRoot(document.getElementById("root")!).render(
        <StrictMode>
            <RouterProvider router={router} />
        </StrictMode>,
    );
});